module.exports = __webpack_public_path__ + "static/makeProfile-2a528f43dd9fd0662e5f5367f52ab072.png";